import React, { useCallback, useEffect, useState } from "react";
import OftadehLayout from "../../components/OftadehLayout/OftadehLayout";
import { Alert } from "@material-ui/lab";
import { Link } from "react-router-dom";
import { Box, Paper } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { useIsMounted } from "../../helpers/useIsMounted";
import { useStore } from "../../stores/helpers/useStore";
import RoundHistoryTable from "./RoundHistoryTable";

const RoundHistoryList = () => {
	const isMounted = useIsMounted();
	const [selectedRoom, setSelectedRoom] = useState("");

	const {
		hostsStore: {
			roundList,
			roundListRooms,
			roundListTotal,
			roundListPage,
			roundListLimit,
			getListOfRounds,
		},
		uiStore: { loading },
	} = useStore();

	const fetchRounds = useCallback(
		({
			roomCode = selectedRoom,
			page = roundListPage,
			limit = roundListLimit,
		} = {}) =>
			getListOfRounds({
				roomCode: roomCode || null,
				page,
				limit,
			}),
		[getListOfRounds, roundListLimit, roundListPage, selectedRoom]
	);

	useEffect(() => {
		getListOfRounds({ page: 1, limit: 50 });
	}, [getListOfRounds]);

	const handleRoomChange = (roomCode) => {
		setSelectedRoom(roomCode);
		fetchRounds({ roomCode, page: 1 });
	};

	const handlePageChange = (nextPage) => {
		fetchRounds({ page: nextPage });
	};

	const handleLimitChange = (nextLimit) => {
		fetchRounds({ page: 1, limit: nextLimit });
	};

	const roomCodes = (roundListRooms || [])
		.map((room) => room.roomCode)
		.filter(Boolean)
		.sort();

	return (
		<OftadehLayout loading={loading || !isMounted}>
			<Box style={{ marginBottom: "20px" }}>
				<h2>Previous Round Data</h2>
				<Link to="/game-history">Go to Game History</Link>
			</Box>

			<Paper style={{ padding: "5px" }}>
				<RoundHistoryTable
					roundList={roundList}
					total={roundListTotal}
					page={roundListPage}
					limit={roundListLimit}
					selectedRoom={selectedRoom}
					roomCodes={roomCodes}
					onRoomChange={handleRoomChange}
					onRefresh={() => fetchRounds({ page: roundListPage })}
					onPageChange={handlePageChange}
					onLimitChange={handleLimitChange}
				/>
			</Paper>

			{!roundList.length && !loading && (
				<Alert severity="info" style={{ marginTop: "16px" }}>
					{selectedRoom
						? "No saved rounds match the selected room."
						: "No rounds have been historically saved yet."}
				</Alert>
			)}
		</OftadehLayout>
	);
};

export default observer(RoundHistoryList);
